import React from 'react';
import { List as ListIcon } from '@mui/icons-material';
import Tile from '../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../common/components/TableEnhanced/TableEnhancedContainer';

const UpdateJobDetails = (props) => {
  return (
    <Tile
      TitleIcon={ListIcon}
      title={'My instruments from Update job ' + props.updateJobName}
      helpTag="update_job"
    >
      <TableEnhancedContainer
        data={props.data}
        columns={props.columnConfigs}
        className="UpdateJobTable"
        enableHideColumns={true}
        enableActionButtons={true}
      />
    </Tile>
  );
};

export default UpdateJobDetails;
